import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { salvarComentarioAnexo, salvarComentarioAnexoFormularioReqCompra } from '@app/api/demanda';
import { Button, Icon } from '@digital/ui';
import ListMensagem from './ListMensagemAnexoFormularioReqCompra';
import TextArea from 'antd/lib/input/TextArea';

export interface PropsModalComentario {
  anexoId: string;
  contemComentario: boolean;
  preSuprimentos: boolean | undefined;
  disabled?: boolean;
}

const ModalComentariosAnexoFormularioReqCompra = (props: PropsModalComentario) => {
  const { anexoId, contemComentario, preSuprimentos, disabled } = props;
  const [recarregarMensagem, setRecarregarMensagem] = useState(false);
  const [exibirModal, setExibirModal] = useState(false);
  const [iconeComentario, setIconeComentario] = useState('');
  const textAreaId = `textAreaId${anexoId}`;

  useEffect(() => {
    if (contemComentario === true) {
      MudarIconeAnexo();
    }
  }, [contemComentario]);

  const MudarIconeAnexo = () => {
    setIconeComentario('has-comments');
  };

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId) as any;
    if (elemento != null) {
      elemento.value = '';
    }
  };

  const getAll = async () => {
    setRecarregarMensagem(!recarregarMensagem);
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    const elemento = document.getElementById(textAreaId) as any;
    const form = new FormData();
    form.append('anexoId', anexoId);
    if (elemento != null) {
      form.append('mensagem', elemento.value);
    }
    form.append('preSuprimentos', preSuprimentos ? '1' : '0');

    salvarComentarioAnexoFormularioReqCompra(form).then((data: any) => {
      if (data && data.valid) {
        limparCampo();
        setRecarregarMensagem(!recarregarMensagem);
        MudarIconeAnexo();
      }
    });
  };

  return (
    <>
      <Tooltip title="Comentários">
        <Button
          type='link'
          onClick={() => {
            getAll();
            showModal();
          }}
          icon="messaging-comments"
          className={iconeComentario}
          disabled={disabled}
          id="mrn-button-modal-comentario-anexo-formulario-req-compra"
        />
      </Tooltip>
      <Modal
        title="Comentário"
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button type="link" onClick={() => handleCancel()}
            id='mrn-button-comentario-anexo-formulario-req-compra-fechar'
          >
            Fechar
          </Button>,
          <Button key="submit" type="primary"
            id='mrn-button-comentario-anexo-formulario-req-compra-enviar'
            onClick={e => Salvar(e)}>
            Enviar
          </Button>,
        ]}>
        {anexoId && <ListMensagem anexoId={anexoId} recarregarMensagem={recarregarMensagem} />}
        <div className="chat-modal-message-box">
          <Form>
            <Form.Item>
              <TextArea id={textAreaId} placeholder="mensagem" autosize={{ minRows: 3, maxRows: 5 }} maxLength={300} />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default ModalComentariosAnexoFormularioReqCompra;
